import React from "react";
import { Box } from "@mui/material";

const ICON_COLOR = "#0f172a";
const VERIFIED_COLOR = "#d4af37";
const BACKGROUND_COLOR = "#f1f5f9";

/** Hat-and-sunglasses glyph drawn on a 24×24 grid. */
export function IncognitoGlyph({ size = 24, color = ICON_COLOR }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M7 10 L8.3 4.6 C8.5 3.8 9.3 3.4 10 3.7 L12 4.5 L14 3.7 C14.7 3.4 15.5 3.8 15.7 4.6 L17 10 Z"
        fill={color}
      />
      <rect x="2.5" y="10" width="19" height="1.6" rx="0.8" fill={color} />
      <circle cx="8.3" cy="16.2" r="3.1" fill={color} />
      <circle cx="15.7" cy="16.2" r="3.1" fill={color} />
      <rect x="11" y="15.5" width="2" height="1.1" rx="0.4" fill={color} />
    </svg>
  );
}

/**
 * Avatar shown in place of an author's photo on anonymous posts and comments.
 * Gold when the hidden author has verified their identity.
 */
export default function IncognitoAvatar({ size = 40, verified = false }) {
  const color = verified ? VERIFIED_COLOR : ICON_COLOR;
  return (
    <Box
      role="img"
      aria-label={verified ? "Anonymous, verified" : "Anonymous"}
      sx={{
        width: size,
        height: size,
        minWidth: size,
        borderRadius: "50%",
        bgcolor: BACKGROUND_COLOR,
        border: verified ? `2px solid ${VERIFIED_COLOR}` : "none",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <IncognitoGlyph size={Math.round(size * 0.62)} color={color} />
    </Box>
  );
}
